import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HomePage } from "../../home/home";
import { ConfigurationServices } from '../../configuration/services';
import { OrdersCoServices } from '../services';
import { TakeawayServices } from '../../takeaway/services';
import { TPVServices } from '../../tpv/services';
import { BlockScreenPage } from '../../components/block-screen/block-screen';
import { OrdersRoomPage } from '../orders-rooms/orders-rooms';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-loader',
  templateUrl: 'orders-loader.html',
})
export class OrdersLoaderPage {

  first_enter: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public takeawayServices: TakeawayServices,
    public tpvServices: TPVServices) {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    // Limpiar tags al entrar en el loader
    this.ordersCoServices.dish_tags = Array();
    this.ordersCoServices.products_tags = Array();

    // Cargar solo lo mínimo necesario para mostrar la interfaz
    this.loadCriticalData().then(() => {
      loadingPopup.dismiss();
      if (this.globals.restaurant.acces_code) {
        this.navCtrl.push(BlockScreenPage, {
          type: 'orders',
        });
      } else {
        this.globals.side_menu_active = 'order';
        this.navCtrl.setRoot(OrdersRoomPage);
        // Iniciar carga en segundo plano con prioridades
        this.loadBackgroundData();
      }
    });
  }
  async loadCriticalData() {
    // Solo cargar datos críticos para mostrar la primera pantalla
    await Promise.all([
      // Configuración del restaurante (necesario para todo)
      this.configurationServices.getRestaurant(this.globals.restaurant_uid),
      
      // Solo las mesas activas
      this.tpvServices.getTables(this.globals.restaurant_uid),
      
    ]);
  }

  async loadBackgroundData() {
    // Cargar datos en segundo plano con prioridades
    // Prioridad 1: Datos básicos de navegación
    await this.loadNavigationData();
    
    // Prioridad 2: Datos de menús y platos básicos
    await this.loadBasicMenuData();
    
    // Prioridad 3: Datos adicionales
    await this.loadAdditionalData();
  }

  async loadNavigationData() {
    await Promise.all([
      this.tpvServices.getRooms(this.globals.restaurant_uid),
      this.ordersCoServices.getRooms(this.globals.restaurant_uid),
      this.ordersCoServices.getTables(this.globals.restaurant_uid)
    ]);
  }

  async loadBasicMenuData() {
    // Cargar solo los primeros 5 elementos de cada tipo
    await Promise.all([
      this.ordersCoServices.getMenus(this.globals.restaurant_uid),
      this.ordersCoServices.getCombos(this.globals.restaurant_uid),
      this.ordersCoServices.getDish(this.globals.restaurant_uid),
      this.ordersCoServices.getProducts(this.globals.restaurant_uid)
    ]);
  }

  async loadAdditionalData() {
    // Cargar el resto de datos en segundo plano
    setTimeout(async () => {
      await Promise.all([
        // TPV - datos adicionales
        this.tpvServices.getCashs(this.globals.restaurant_uid),
        this.ordersCoServices.getCashs(this.globals.restaurant_uid),
        
        // Favoritos y datos completos
        this.ordersCoServices.getFavouriteMenus(this.globals.restaurant_uid),
        this.ordersCoServices.favourite_dishs,
        this.ordersCoServices.favourite_products,
        
        // Cargar el resto de datos
        this.ordersCoServices.getMenus(this.globals.restaurant_uid),
        this.ordersCoServices.getCombos(this.globals.restaurant_uid),
        this.ordersCoServices.getDish(this.globals.restaurant_uid),
        this.ordersCoServices.getProducts(this.globals.restaurant_uid)
      ]);
    }, 500);
  }

  ionViewCanEnter() {
    if (this.first_enter) {
      this.first_enter = false;
    } else {
      this.globals.side_menu_active = 'dashboard';
      this.navCtrl.setRoot(HomePage);
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-loader/orders-loader.ts